export function spinner(ctx) {
    return {
        styles: {
            // background arc (main) line = arc_bg. line_width: 25 matches firmware
            // (lv_theme_material.c:514, LV_DPX(25)) — was 15, overriding the schema's own
            // already-correct Phase 1 default (25). bg_color/bg_opa/border/radius are inert
            // (SPINNER_PART_BG only gets `arc_bg`, never `bg` — no rect is themed at all) but
            // harmlessly zeroed/transparent, matching firmware's effective "no background".
            main:      { bg_color: ctx.COLOR_SCR, bg_opa: 0, border_width: 0, border_color: 'black', radius: 0, line_color: ctx.COLOR_BG_SEC, line_width: 25 },
            // indicator arc = arc_indic. line_width: 25 matches firmware (lv_theme_material.c:509)
            // — was 15, same bug as main.
            indicator: { line_color: ctx.primary, line_width: 25, line_rounded: true },
        },
    };
}
